module.exports = __webpack_public_path__ + "img/presentation-office.5fb8177c.png";